export interface CpmStackedSegment {
    key: string;
    value: number;
    color: string;
}

interface CpmStackedProgressBarProps {
    segments: CpmStackedSegment[];
    height?: number;
    className?: string;
}

/** Horizontal stacked bar — Catalog health / Link decisions. */
export default function CpmStackedProgressBar({
    segments,
    height = 8,
    className = '',
}: CpmStackedProgressBarProps) {
    const total = segments.reduce((sum, s) => sum + Math.max(0, s.value), 0);

    return (
        <div
            className={[
                'flex rounded-full overflow-hidden bg-[var(--cpm-surface-skeleton)]',
                className,
            ].join(' ')}
            style={{ height }}
        >
            {total <= 0
                ? null
                : segments.map((seg) => {
                      if (seg.value <= 0) return null;
                      const pct = (seg.value / total) * 100;
                      return (
                          <span
                              key={seg.key}
                              style={{
                                  width: `${pct}%`,
                                  background: seg.color,
                                  height: '100%',
                                  display: 'block',
                                  flex: 'none',
                              }}
                          />
                      );
                  })}
        </div>
    );
}
